module.exports = __webpack_public_path__ + "jtails-build/img/pattern-1-dark.532b5c19.svg";